import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import { generateReactKey } from '../../utils/shared/commonUtils';

const WebEntryPanelContent = ({
    headerCells,
    rowsData,
    studentsByGradeData,
    isPmPanelType,
    panelType,
    rowStatuses,
    invalidateResult,
    isEditable,
    errors,
    processValidationAndSaving,
    webEntryClassName,
    assessmentType,
    isChosenSchoolWindowDatesStrictlyEnforced,
    isSecurePeriod,
}) => {
    const [selectedGradeDate, setSelectedGradeDate] = useState(null);

    return studentsByGradeData.map(({ grade, gradeTitle, studentsData }, gradeIndex) => {
        const isSingleGrade = studentsByGradeData.length === 1;
        const isFirstGradeInList = gradeIndex === 0;
        return (
            <Fragment key={generateReactKey(`table-${grade}`)}>
                <TableHeader
                    key={generateReactKey(`header-${grade}`)}
                    gradeTitle={gradeTitle}
                    isSingleGrade={isSingleGrade}
                    isFirstGradeInList={isFirstGradeInList}
                    headerCells={headerCells}
                    webEntryClassName={webEntryClassName}
                />
                {studentsData.map((studentData, index) => {
                    const { firstName, lastName } = studentData.studentInfo;
                    const isFirstStudentInList = index === 0;
                    const result = !isPmPanelType ? studentData.bmResult : studentData.pmResult;
                    return (
                        <TableRow
                            key={`${firstName}-${lastName}`}
                            isFirstStudentInList={isFirstStudentInList}
                            isEditable={isEditable}
                            webEntryClassName={webEntryClassName}
                            assessmentType={assessmentType}
                            result={result}
                            studentInfo={studentData.studentInfo}
                            grade={grade}
                            isPmPanelType={isPmPanelType}
                            panelType={panelType}
                            invalidateResult={invalidateResult}
                            setSelectedGradeDate={setSelectedGradeDate}
                            selectedGradeDate={get(selectedGradeDate, grade, {})}
                            error={errors[studentData.studentInfo.id]}
                            processValidationAndSaving={(rowData, setIsRowFocused) =>
                                processValidationAndSaving(
                                    rowData,
                                    studentData.studentInfo.id,
                                    studentData.studentInfo.temporalId,
                                    grade,
                                    setIsRowFocused,
                                    studentData.studentInfo.temporalInstId,
                                )
                            }
                            rowStatus={rowStatuses[studentData.studentInfo.id]}
                            {...rowsData}
                            isChosenSchoolWindowDatesStrictlyEnforced={
                                isChosenSchoolWindowDatesStrictlyEnforced
                            }
                            isSecurePeriod={isSecurePeriod}
                        />
                    );
                })}
            </Fragment>
        );
    });
};
WebEntryPanelContent.defaultProps = {
    studentsByGradeData: [],
    header: {},
    row: {},
    isPmPanelType: false,
    panelType: null,
    rowStatuses: null,
    invalidateResult: () => {},
    isEditable: false,
    errors: null,
    processValidationAndSaving: () => {},
    assessmentType: '',
    isSecurePeriod: false,
};

WebEntryPanelContent.propTypes = {
    studentsByGradeData: PropTypes.array,
    header: PropTypes.object,
    row: PropTypes.object,
    isPmPanelType: PropTypes.bool,
    panelType: PropTypes.string,
    rowStatuses: PropTypes.object,
    invalidateResult: PropTypes.func,
    isEditable: PropTypes.bool,
    errors: PropTypes.object,
    processValidationAndSaving: PropTypes.func,
    assessmentType: PropTypes.string,
    isSecurePeriod: PropTypes.bool,
};

export default WebEntryPanelContent;
